import React from 'react';
import './App.css';
import Particles from 'react-particles-js';
import Icon from '@material-ui/core/Icon';
import { FaLinkedin } from "react-icons/fa";
import { IconContext } from "react-icons";

const particleOpt = {
  particles: {
    number: {
      value: 308,
      density: {
        enable: true,
        value_area: 800
      }
    },
    color: {
      value: '#fff'
    },
    shape: {
      type: 'circle',
      stroke: {
        width: 0,
        color: '#000000'
      },
      polygon: {
        nb_sides: 5
      },
      image: {
        src: 'img/github.svg',
        width: '100%',
        height: '100%'
      }
    },
    opacity: {
      value: 0.5,
      random: true,
      anim: {
        enable: false,
        speed: 1,
        opacity_min: 0.1,
        sync: false
      }
    },
    size: {
      value: 10,
      random: true,
      anim: {
        enable: true,
        speed: 40,
        size_min: 0.1,
        sync: true
      }
    },
    line_linked: {
      enable: false,
      distance: 500,
      color: '#ffffff',
      opacity: 0.4,
      width: 2
    },
    move: {
      enable: true,
      speed: 6,
      direction: 'bottom',
      random: false,
      straight: false,
      out_mode: 'bounce',
      bounce: false,
      attract: {
        enable: false,
        rotateX: 600,
        rotateY: 1200
      }
    }
  },
  interactivity: {
    detect_on: 'canvas',
    events: {
      onhover: {
        enable: true,
        mode: 'bubble'
      },
      onclick: {
        enable: false,
        mode: 'bubble'
      },
      resize: true
    },
    modes: {
      grab: {
        distance: 400,
        line_linked: {
          opacity: 0.5
        }
      },
      bubble: {
        distance: 400,
        size: 4,
        duration: 0.3,
        opacity: 1,
        speed: 3
      },
      repulse: {
        distance: 200,
        duration: 0.4
      },
      push: {
        particles_nb: 4
      },
      remove: {
        particles_nb: 2
      }
    }
  },
  retina_detect: true
}


function App() {
  return (
    <div >
        <header id="fh5co-header" clss="fh5co-cover js-fullheight" role="banner" data-stellar-background-ratio="0.5">
          <div className="overlay" id="particles-js">
            <Particles 
                params={particleOpt} 
              />
          </div>
        <div className="container">
          <div className="row">
            <div className="col-md-6 col-md-offset-6 text-center">
              <div className="display-t js-fullheight">
                <div className="display-tc js-fullheight animate-box" data-animate-effect="fadeIn">
                  <div className="content_wrapper">
                    <h1><span>Jinesh Malavia</span></h1>
                    <h3 style={{position:'relative', fontFamily:'Kaushan Script', fontSize:25}}><span >Full Stack Developer</span></h3>
                    <span><Icon>fa-plus-circle</Icon></span>
                    {/* <p> */}
                      <ul className="fh5co-social-icons">
                        <li style={{position:"absolute"}}><a href="https://www.linkedin.com/in/jinesh-malavia-a578a4148/">
                          <IconContext.Provider value={{ className: "global-class-name", size:25 }}>
                            <div><FaLinkedin style={{size:30}}/></div>
                          </IconContext.Provider>
                        </a></li>
                        <li><a href="addition.html"><i className="icon-star"></i></a></li>
                        <li><a href="addition.html"><i className="icon-star"></i></a></li>
                      </ul>
                    {/* </p> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>        
    </div>
  );
}

export default App;
